import { API_ENDPOINTS } from "../constants/apiEndpoints";
import axiosInstance from "../config/axiosInstance";

/**
 * Lấy toàn bộ danh sách danh mục (categories) Sản phẩm - Giải pháp theo ngôn ngữ
 * @param {string} languageCode - Mã ngôn ngữ (vd: 'vi', 'en', 'jp')
 * @returns {Promise<Array>} - Mảng categories:
 *   [{ id, productSolutionGroupId, groupName, groupSlug, image, sortOrder, name, slug }]
 */
export const getProductSolutionCategories = async (languageCode) => {
    try {
        const response = await axiosInstance.get(
            API_ENDPOINTS.PRODUCT_SOLUTION_CATEGORIES.GET_BY_LANGUAGE(languageCode)
        );
        const data = response.data;

        if (data && data.success && Array.isArray(data.data)) {
            return data.data;
        } else if (Array.isArray(data)) {
            return data;
        }

        return [];
    } catch (error) {
        console.error(`[ProductSolutionCategories] Lỗi khi lấy categories (lang=${languageCode}):`, error.message ?? error);
        throw error;
    }
};
